import React, { useEffect } from 'react';
import { ProgramProvider } from './contexts/ProgramContext';
import { Home } from './pages/Home';
export function App() {
  useEffect(() => {
    document.title = 'Bates Taekwondo | Taekwondo for Kids, Teens & Adults in Albuquerque, NM';
    let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex, nofollow';
  }, []);
  return <ProgramProvider data-id="element-0" data-mp="2mnnhy8to8k3e">
      <Home data-id="element-1" data-mp="2mjzmv58kvpmk" />
    </ProgramProvider>;
}